// Sound effects using Web Audio API
const audioContext = typeof window !== 'undefined' ? new (window.AudioContext || window.webkitAudioContext)() : null;

function playTone(frequency, duration, type = 'sine', volume = 0.3) {
  if (!audioContext) return;
  
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();
  
  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);
  
  oscillator.frequency.value = frequency;
  oscillator.type = type;
  
  gainNode.gain.setValueAtTime(volume, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + duration);
  
  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + duration);
}

export function playMoveSound() {
  playTone(440, 0.08, 'sine', 0.2);
}

export function playCaptureSound() {
  playTone(330, 0.1, 'square', 0.25);
  setTimeout(() => playTone(220, 0.1, 'square', 0.2), 50);
}

export function playCheckSound() {
  playTone(880, 0.15, 'sine', 0.3);
  setTimeout(() => playTone(660, 0.15, 'sine', 0.2), 100);
}

export function playGameEndSound(isWin) {
  if (isWin) {
    // Victory fanfare
    playTone(523, 0.15, 'sine', 0.3);
    setTimeout(() => playTone(659, 0.15, 'sine', 0.3), 150);
    setTimeout(() => playTone(784, 0.2, 'sine', 0.3), 300);
  } else {
    // Defeat sound
    playTone(440, 0.2, 'sine', 0.3);
    setTimeout(() => playTone(330, 0.2, 'sine', 0.3), 200);
    setTimeout(() => playTone(262, 0.3, 'sine', 0.3), 400);
  }
}

export function playErrorSound() {
  playTone(200, 0.15, 'sawtooth', 0.2);
}

export function playHintSound() {
  playTone(880, 0.08, 'sine', 0.2);
  setTimeout(() => playTone(1100, 0.08, 'sine', 0.2), 80);
}

export function playBlunderSound() {
  playTone(200, 0.2, 'triangle', 0.3);
  setTimeout(() => playTone(150, 0.3, 'triangle', 0.2), 150);
}

export function playExcellentSound() {
  playTone(660, 0.1, 'sine', 0.2);
  setTimeout(() => playTone(880, 0.15, 'sine', 0.25), 100);
}
